import React from 'react';

const CGVPage = () => {
  return (
    <div className="min-h-screen pt-20 bg-[#FAFAFA]" data-testid="cgv-page">
      <div className="bg-[#0A0A0A] text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-['Playfair_Display'] mb-4">Conditions Générales de Vente</h1>
        </div>
      </div>
      <div className="container-custom py-12 max-w-3xl">
        <div className="bg-white border border-[#E5E5E5] p-8 md:p-12 space-y-8 font-['Outfit']">
          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">1. Réservation</h2>
            <p className="text-[#666666] mb-4">
              La réservation est considérée comme ferme et définitive après paiement du montant total du séjour.
            </p>
            <ul className="list-disc list-inside text-[#666666] space-y-2">
              <li>Tarif : 800€ par nuit</li>
              <li>Minimum : 2 nuits</li>
              <li>Capacité standard : 1 à 12 personnes</li>
              <li>Au-delà de 12 personnes : sur devis</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">2. Caution</h2>
            <p className="text-[#666666]">
              Une caution de 2 000€ est demandée sous forme d'empreinte bancaire (non débitée). 
              Elle sera libérée après l'état des lieux de sortie, sauf en cas de dommages constatés.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">3. Horaires</h2>
            <p className="text-[#666666]">
              <strong>Arrivée :</strong> à partir de 12h00<br />
              <strong>Départ :</strong> avant 12h00<br />
              Les horaires peuvent être flexibles sur demande et selon disponibilités.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">4. Politique d'annulation</h2>
            <ul className="list-disc list-inside text-[#666666] space-y-2">
              <li><strong>Plus de 14 jours avant l'arrivée :</strong> remboursement intégral (100%)</li>
              <li><strong>Entre 7 et 14 jours :</strong> remboursement de 50%</li>
              <li><strong>Moins de 7 jours :</strong> aucun remboursement</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">5. Option ménage</h2>
            <p className="text-[#666666]">
              Une option ménage à 300€ est proposée. Sans cette option, la maison doit être rendue 
              dans un état de propreté correct (vaisselle faite, poubelles vidées).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">6. Règlement intérieur</h2>
            <ul className="list-disc list-inside text-[#666666] space-y-2">
              <li>Respect du lieu et du voisinage</li>
              <li>Fêtes autorisées (le domaine est isolé)</li>
              <li>Animaux acceptés</li>
              <li>Piscine en travaux actuellement</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">7. Paiement</h2>
            <p className="text-[#666666]">
              Le paiement s'effectue par carte bancaire via notre plateforme sécurisée Stripe. 
              Le montant total est prélevé au moment de la réservation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-['Playfair_Display'] mb-4">8. Responsabilité</h2>
            <p className="text-[#666666]">
              Le locataire est responsable des dommages causés au domaine pendant son séjour. 
              Une assurance responsabilité civile est recommandée.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGVPage;
